// Spin to Win sheet in the cart drawer (snippets/cart-spin-sheet.liquid).
// A bottom sheet inside the drawer: closed = slim bar, open = the wheel. Tap the bar to toggle, drag it up/down,
// X hides it for this visit (sessionStorage).

const DISMISS_KEY = 'monk-spin-sheet-dismissed';

class SpinSheet extends HTMLElement {
  connectedCallback() {
    this.handle = this.querySelector('[data-spin-sheet-handle]');
    this.panel = this.querySelector('.spin-sheet__panel');
    this.dismissButton = this.querySelector('[data-spin-sheet-dismiss]');
    try {
      if (sessionStorage.getItem(DISMISS_KEY)) {
        this.hidden = true;
        return;
      }
    } catch {
      // Ignore.
    }
    this.dismissButton?.addEventListener('click', () => this.dismiss());
    this.handle?.addEventListener('pointerdown', (event) => this.dragStart(event));
    this.handle?.addEventListener('click', (event) => {
      if (this.dragged) {
        event.preventDefault();
        this.dragged = false;
        return;
      }
      this.setOpen(!this.hasAttribute('data-open'));
    });
    // Fold away when the cart drawer closes.
    this.closest('dialog')?.addEventListener('close', () => this.setOpen(false));
  }

  setOpen(open) {
    this.style.removeProperty('--spin-sheet-drag');
    this.toggleAttribute('data-open', open);
    this.handle?.setAttribute('aria-expanded', String(open));
    if (this.panel) this.panel.inert = !open;
  }

  dismiss() {
    this.setOpen(false);
    this.hidden = true;
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // Ignore.
    }
  }

  // Drag the bar: follow the finger, then snap open or closed.
  dragStart(event) {
    if (event.button !== undefined && event.button !== 0) return;
    const startY = event.clientY;
    const wasOpen = this.hasAttribute('data-open');
    const travel = Math.max(1, this.offsetHeight - (this.querySelector('.spin-sheet__bar')?.offsetHeight || 0));
    let delta = 0;
    this.dragged = false;
    const move = (e) => {
      delta = e.clientY - startY;
      if (Math.abs(delta) > 6) this.dragged = true;
      if (!this.dragged) return;
      this.setAttribute('data-dragging', '');
      // 0 = fully open, travel = fully closed.
      const offset = Math.min(travel, Math.max(0, (wasOpen ? 0 : travel) + delta));
      this.style.setProperty('--spin-sheet-drag', `${offset}px`);
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
      window.removeEventListener('pointercancel', up);
      this.removeAttribute('data-dragging');
      if (!this.dragged) return;
      const threshold = Math.min(80, travel / 4);
      if (wasOpen) this.setOpen(delta < threshold);
      else this.setOpen(delta < -threshold);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
  }
}

if (!customElements.get('s-spin-sheet')) customElements.define('s-spin-sheet', SpinSheet);
